export const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];
export const pickIndex = (arr) => Math.floor(Math.random() * arr.length);

